import { withHasPerm } from 'components';

import { RouteObject, Outlet } from 'react-router';
import { superuser } from 'core/permissions';

import * as agencies from './Agencies';
import * as agencyRoles from './AgencyRoles';
import * as users from './Users';
import * as blockStatuses from './BlockStatuses';

const System = withHasPerm(Outlet, superuser);

export const route: RouteObject = {
  path: 'system',
  element: <System />,
  children: [agencies.route, agencyRoles.route, users.route, blockStatuses.route],
};
